/* eslint-disable */

import cloneDeep from "lodash.clonedeep"

type Listener<T> = (event: string, data: T) => void

export class EventEmitter<T> {
  private events: Record<string, Listener<T>[]>

  constructor() {
    this.events = {}
  }

  on(event: string, listener: Listener<T>): void {
    this.events[event] ??= []
    if (this.events[event]) {
      this.events[event]?.push(listener)
    } else {
      this.events[event] = [listener]
    }
  }

  off(event: string, listener: Listener<T>): void {
    this.events[event] ??= []
    if (this.events[event]) {
      this.events[event] = this.events[event]!.filter((l) => l !== listener)
    }
  }

  emit(event: string, data: T): void {
    this.events[event] ??= []
    if (this.events[event]) {
      this.events[event]?.forEach((listener) => {
        // we MUST clone the data before passing it to the listener, to stop cross observer contamination (of altered event data)
        const clonedData = cloneDeep(data)
        listener(event, clonedData)
      })
    }

    // Trigger the '*' event
    if (this.events["*"]) {
      this.events["*"].forEach((listener) => {
        const clonedData = cloneDeep(data)
        listener(event, clonedData)
      })
    }
  }
}
